import { IProfile, profileTabs } from '@/modules/profile/models';
import { IVehicleType, IFlag, ICountry } from '@/models';


export interface State {
    profiles: IProfile[];
    profileSelected: IProfile;
    showRegisterForm: boolean;
    flags: IFlag[];
    currentTab: string;
    vehicleTypes: IVehicleType[];
    countries: ICountry[];
}

export const state = (): State => ({
    profiles: [],
    showRegisterForm: false,
    flags: [],
    vehicleTypes: [],
    countries: [],
    currentTab: profileTabs.tabs.listtab,
    profileSelected: {
        idcountry: 0,
        id: 0,
        idvehicle: 0,
        idflag: 0,
        isactive: true,
        needacceptancetermsofuse: false,
        name: '',
        country: { id: 0, countryname: '' },
        flag: { id: 0, flagname: '' },
        vehicletype: { id: 0, vehicletypename: '' },
        functionalities: [],
    },
});
